import React, { Component } from "react";
import { connect } from "react-redux";
import { getHomepageData } from "../actions/homepageActions";
import { iconMap } from "../utilities/utilities";
import { Link } from "react-router-dom";
import { HomepageTenantUsageWidget } from "./TenantUsageWidget";

import "./Homepage.css";
import { itemCountPagination } from "./Tables/CustomPagination";
import CustomizableTable from "./Tables/CustomizableTable";
import { DEFAULT_COLUMN_WIDTH } from "./Tables/SortableTable";
import InteractiveTableCell from "./Tables/InteractiveTableCell";
import DocumentSlidingPane from "./DocumentPreviewRightPane";
import { withDocumentPreviewPane } from "./useDocumentPreviewPane";
import { IconBriefcase, IconEye } from "@tabler/icons-react";

export const HOMEPAGE_TABLE_IDS = {
	favoriteFolders: "/homepage/favoriteFolders",
	favoriteDocuments: "/homepage/favoriteDocuments",
	openMatters: "/homepage/openMatters",
};

const FolderCountPagination = itemCountPagination("Folder");
const DocumentCountPagination = itemCountPagination("Document");
const MatterCountPagination = itemCountPagination("Matter");

const HOMEPAGE_MAIN_COLUMN_WIDTH = DEFAULT_COLUMN_WIDTH * 1.5;
const HOMEPAGE_ID_COLUMN_WIDTH = 80;

class Homepage extends Component {
	constructor(props, context) {
		super(props, context);

		this.openMatterColumns = [
			{
				Header: () => <div style={{ textAlign: "left" }}>ID</div>,
				accessor: "matterID",
				width: HOMEPAGE_ID_COLUMN_WIDTH,
				Cell: (row) => (
					<div>
						<IconBriefcase
							size={16}
							style={{ verticalAlign: "sub", marginRight: 8 }}
						/>
						<span>{row.original.matterID}</span>
					</div>
				),
			},
			{
				Header: () => <div style={{ textAlign: "left" }}>Name</div>,
				accessor: "matterName",
				width: HOMEPAGE_MAIN_COLUMN_WIDTH,
				Cell: (row) => (
					<InteractiveTableCell
						otherButtons={[
							{
								iconComponent: <IconEye size={20} />,
								title: "Preview This Matter",
								onClick: () => {
									this.props.documentPreviewPane.openItemPreview(
										{
											type: "Matter",
											id: row.original.matterID,
											title: row.original.matterName,
										}
									);
								},
							},
						]}
					>
						<Link
							to={`/matters/${row.original.matterID}/docs/`}
							title={row.original.matterName}
						>
							{row.original.matterName}
						</Link>
					</InteractiveTableCell>
				),
			},
			{
				Header: () => <div style={{ textAlign: "left" }}>Client</div>,
				accessor: "clientName",
				Cell: (row) =>
					row.original.clientName && (
						<div
							title={row.original.clientName}
							style={{ overflow: "hidden" }} // allows the final columns padding to be set if it overflows
						>
							<Link to={`/clients/${row.original.clientID}/`}>
								{row.original.clientName}
							</Link>
						</div>
					),
				width: 150,
			},
		];
		this.favoriteDocumentColumns = [
			{
				Header: <div style={{ textAlign: "left" }}>ID</div>,
				accessor: "id",
				width: HOMEPAGE_ID_COLUMN_WIDTH,
				Cell: (row) => {
					const { iconComponent } = iconMap(row);
					return (
						<div>
							{iconComponent}
							<span>{row.original.id}</span>
						</div>
					);
				},
			},
			{
				Header: <div style={{ textAlign: "left" }}>Name</div>,
				accessor: "filename",
				width: HOMEPAGE_MAIN_COLUMN_WIDTH,
				Cell: (row) => (
					<InteractiveTableCell
						otherButtons={[
							{
								iconComponent: <IconEye size={20} />,
								title: "Preview This Document",
								onClick: () => {
									this.props.documentPreviewPane.openItemPreview(
										{
											type: "File",
											id: row.original.id,
											title: row.original.filename,
											rowData: {
												...row.original,
												isFavorite: true,
											},
										}
									);
								},
							},
						]}
					>
						<Link
							to={`/docs/${row.original.id}`}
							title={row.original.filename}
						>
							{row.original.filename}
						</Link>
					</InteractiveTableCell>
				),
			},
			{
				Header: <div style={{ textAlign: "left" }}>Type</div>,
				accessor: "documentType",
				width: 120,
			},
		];
		this.favoriteFolderColumns = [
			{
				Header: <div style={{ textAlign: "left" }}>Name</div>,
				accessor: "filename",
				width: HOMEPAGE_MAIN_COLUMN_WIDTH,
				Cell: (row) => {
					const { iconComponent } = iconMap(row);
					return (
						<div style={{ display: "flex", alignItems: "center" }}>
							{iconComponent}
							<div title={row.original.filename}>
								<Link to={row.original.url}>
									{row.original.filename}
								</Link>
							</div>
						</div>
					);
				},
			},
			{
				Header: <div style={{ textAlign: "left" }}>Matter</div>,
				accessor: "matterName",
				Cell: (row) => (
					<div
						title={row.original.matterName}
						style={{ overflow: "hidden" }} // allows the final columns padding to be set if it overflows
					>
						<Link to={row.original.linkToMatter}>
							{row.original.matterName}
						</Link>
					</div>
				),
			},
		];
	}
	componentDidMount() {
		this.props.getHomepageData();
	}

	render() {
		return (
			<div className="fullHeightFlex">
				<div
					className="MainFontSemiBold"
					style={{
						marginLeft: 24,
						fontSize: 24,
						marginTop: 12,
					}}
				>
					{this.props.firmName}
				</div>
				<div
					className="Homepage"
					style={{
						height: "100%",
						display: "grid",
						gridTemplateColumns: "1fr 1fr 1fr",
					}}
				>
					<div
						style={{
							padding: 24,
							display: "flex",
							flexDirection: "column",
							height: "100%",
						}}
					>
						<div>
							<div className="MainFontBold">
								My Favorite Folders
							</div>
							<CustomizableTable
								className="fullWidth homepageFavoriteFoldersTable"
								tableStyle={{ height: 350 }}
								columns={this.favoriteFolderColumns}
								data={this.props.myFavoriteFolders || []}
								defaultPageSize={8}
								defaultSorted={[
									{
										id: "filename",
										desc: true,
									},
								]}
								uncontrolledPagination
								PaginationComponent={FolderCountPagination}
								loading={this.props.loading}
								noResultsText="No Favorite Folders"
								tableUniqueID={
									HOMEPAGE_TABLE_IDS.favoriteFolders
								}
								hideColumnsButton
								noAutoResize
							/>
						</div>
						<HomepageTenantUsageWidget />
					</div>

					<div style={{ padding: 24 }}>
						<div className="MainFontBold">
							My Favorite Documents
						</div>
						<CustomizableTable
							className="fullWidth homepageFavoriteDocumentsTable"
							tableStyle={{ height: 595 }}
							columns={this.favoriteDocumentColumns}
							data={this.props.myFavoriteDocuments || []}
							defaultPageSize={14}
							defaultSorted={[
								{
									id: "id",
									desc: true,
								},
							]}
							uncontrolledPagination
							PaginationComponent={DocumentCountPagination}
							loading={this.props.loading}
							noResultsText="No Favorite Documents"
							tableUniqueID={HOMEPAGE_TABLE_IDS.favoriteDocuments}
							hideColumnsButton
							noAutoResize
						/>
					</div>

					<div style={{ padding: 24 }}>
						<div className="MainFontBold">My Open Matters</div>
						<CustomizableTable
							className="fullWidth homepageOpenMattersTable"
							tableStyle={{ height: 595 }}
							columns={this.openMatterColumns}
							data={this.props.myOpenMatters || []}
							defaultPageSize={14}
							defaultSorted={[
								{
									id: "matterID",
									desc: true,
								},
							]}
							uncontrolledPagination
							PaginationComponent={MatterCountPagination}
							loading={this.props.loading}
							noResultsText="No Open Matters"
							tableUniqueID={HOMEPAGE_TABLE_IDS.openMatters}
							hideColumnsButton
							noAutoResize
						/>
					</div>
				</div>
				<DocumentSlidingPane
					openPane={this.props.documentPreviewPane.previewOpen}
					selectedRowData={
						this.props.documentPreviewPane.previewSelectedRow ?? {}
					}
					closeRightPane={this.props.documentPreviewPane.closePreview}
				/>
			</div>
		);
	}
}
const mapStateToProps = (state) => ({
	myOpenMatters: state.homepage.myOpenMatters,
	myFavoriteDocuments: state.homepage.myFavoriteDocuments,
	myFavoriteFolders: state.homepage.myFavoriteFolders,
	firmName: state.user.firmName,
});
export default connect(mapStateToProps, { getHomepageData })(
	withDocumentPreviewPane(Homepage)
);
